module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"info":"Информация","car_number":"Номер вагона","project":"Проект","subproject":"Подпроект","cargo_name":"Тип груза"},"en":{"info":"Information","car_number":"Car number","project":"Project","subproject":"Subproject","cargo_name":"Cargo"}}')
  delete Component.options._Ctor
}
